/**
 * @generated SignedSource<<14f3fd5c42e4adc82124105009035edd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExtProjectLinkUpdateInput = {
  link_ext_project_ids?: ReadonlyArray<number> | null | undefined;
  project_id: number;
  unlink_ext_project_ids?: ReadonlyArray<number> | null | undefined;
};
export type ExtProjectLinks_updateMutation$variables = {
  input: ExtProjectLinkUpdateInput;
};
export type ExtProjectLinks_updateMutation$data = {
  readonly action_ext_project_link_update: {
    readonly project: {
      readonly id: number;
      readonly " $fragmentSpreads": FragmentRefs<"ExtLinks_Project">;
    } | null | undefined;
  } | null | undefined;
};
export type ExtProjectLinks_updateMutation = {
  response: ExtProjectLinks_updateMutation$data;
  variables: ExtProjectLinks_updateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExtProjectLinks_updateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExtProjectLinkUpdateOutput",
        "kind": "LinkedField",
        "name": "action_ext_project_link_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExtLinks_Project"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExtProjectLinks_updateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExtProjectLinkUpdateOutput",
        "kind": "LinkedField",
        "name": "action_ext_project_link_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "active": {
                        "_eq": true
                      }
                    }
                  }
                ],
                "concreteType": "ext_project_link",
                "kind": "LinkedField",
                "name": "ext_project_links",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "project_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_project_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": "external_id",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_project_id",
                    "storageKey": null
                  },
                  {
                    "alias": "external",
                    "args": null,
                    "concreteType": "ext_project",
                    "kind": "LinkedField",
                    "name": "ext_project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integration_id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ext_project_links(where:{\"active\":{\"_eq\":true}})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa98c36ddd521da74a33b4978c55c39f",
    "id": null,
    "metadata": {},
    "name": "ExtProjectLinks_updateMutation",
    "operationKind": "mutation",
    "text": "mutation ExtProjectLinks_updateMutation(\n  $input: ExtProjectLinkUpdateInput!\n) {\n  action_ext_project_link_update(input: $input) {\n    project {\n      id\n      ...ExtLinks_Project\n    }\n  }\n}\n\nfragment ExtLinks_Project on projects {\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n    active\n    external_id: ext_project_id\n    external: ext_project {\n      id\n      __typename\n      name\n      remote_url\n      remote_id\n      integration_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "719214ce87d8c0e03ec242aec297ad72";

export default node;
